import React from "react";
import styled from "styled-components";

const Container = styled.h4`
  font-weight: bold;
`;

function Title({ children }) {
  return <Container>{children}</Container>;
}

export { Title };
